import _ from "lodash"
import {
    faCamera, faDrawSquare,
    faFastBackward,
    faFastForward,
    faMoon,
    faSun, faTachometer, faTag
} from "@fortawesome/pro-solid-svg-icons";

export const TOGGLE_TAG_PAIRS = [["Forward", "Backward"], ["Day", "Night"]];

export const tagIcons = {
    sun: {
        icon: faSun,
        color: "yellow"
    },
    moon: {
        icon: faMoon,
        color: "black"
    },
    fastForward: {
        icon: faFastForward,
    },
    fastBackward: {
        icon: faFastBackward,
    },
    camera: {
        icon: faCamera,
        color: "blue"
    },
    Detection: {
        icon: faDrawSquare,
        color: "purple"
    },
}

export const tagCategoryProperties = {
    "Day / Night": {
        priority: 1,
        defaultOpen : true
    },
    "Forward / Backward": {
        priority: 2,
        defaultOpen : true
    },
    "Video Type": {
        priority: 3,
        defaultOpen : true
    },
    "Detection": {
        priority: 4,
        defaultOpen : false
    },
    "Zone": {
        priority: 5,
        defaultOpen : false
    },
    "Other": {
        priority: 6,
        defaultOpen: false
    }
}

export const filterSessionTags = (sessionTags, detectionTypes, whitelistFilters) => {
    let filteredTags = [];
    sessionTags.forEach(tag => {
        const detectionType = _.find(detectionTypes, { type: tag.tag });
        if (detectionType && detectionType.display_type === "never") {
            return;
        }
        
        filteredTags.push({
            ...tag,
            display_name: detectionType?.display_name
        })
    })

    if (whitelistFilters && whitelistFilters.length > 0) {
        filteredTags = filteredTags.filter(tag => whitelistFilters.map(item => item.toLowerCase()).includes(tag.tag.toLowerCase()))
    }

    filteredTags = _.uniqBy(filteredTags, "tag");

    return _.groupBy(filteredTags, tag => {
        if (tag.category) {
            return tag.category;
        } else {
            if (tag.source === "marker" || tag.tag_type === "detection") {
                return "Detection";
            } else if (tag.source === "zone") {
                return "Zone";
            } else if (tag.source === "aoi") {
                return "Area Of Interest";
            }
        }
        return "Other";
    });
};
